declare let toastr:any;
export class MessageStorage{
  
  static add(messageType: "success" | "error" | "warning" | "info", message: string){
    if (message !== null) {

      toastr.options.closeButton = (true);
      toastr.options.positionClass = 'toast-bottom-right';
      toastr.options.progressBar = true;
      toastr.options.preventDuplicates=true;

      toastr[messageType](message, '');
    }
  }
}